import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/purchases/…` → `/{store}/purchases/…`. */
export const Route = createFileRoute("/purchases/$")({ beforeLoad: redirectIntoScope });
